class YtSDK {
  constructor() {
    this.API_KEY = "AIzaSyAhqduLg2xbAcL-uftbnqFMhu7SucGWiBo";
    this.ready = new Promise(resolve => {
      window.gapi.load("client", () => {
        resolve(this.loadClient());
      });
    });
  }

  loadClient = () => {
    window.gapi.client.setApiKey(this.API_KEY);
    return window.gapi.client.load(
      "https://www.googleapis.com/discovery/v1/apis/youtube/v3/rest"
    );
  };

  async getVideoInfos(id) {
    await this.ready;

    const res = await gapi.client.youtube.videos.list({
      part: ["snippet,statistics"],
      id: id,
    });

    let data = {
      video: res.result.items[0],
    };

    const channel = await this.getChannelInfos(data.video.snippet.channelId);
    data.channel = channel;

    return data;
  }

  getChannelInfos(id) {
    var request = window.gapi.client.youtube.channels.list({
      id,
      part: "snippet",
    });

    return request.then(
      function (res) {
        let channel = res.result.items[0];
        return channel;
      },
      function (reason) {
        console.log("Error: " + reason.result.error.message);
      }
    );
  }
}

export default new YtSDK();



/** WEBPACK FOOTER **
 ** ./src/scripts/sdks/YtSDK.js
 **/